var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.794 2.64145C18.474 3.54145 21.654 7.59545 21.494 12.4144C21.347 16.8584 17.752 20.7324 13.224 21.2874C11.4055 21.5171 9.55941 21.2185 7.906 20.4274C7.64161 20.3124 7.34765 20.2837 7.066 20.3454C5.71 20.6704 4.365 21.0394 3.016 21.3904C2.868 21.4284 2.716 21.4544 2.5 21.4994C2.905 20.0174 3.283 18.5954 3.687 17.1794C3.79 16.8214 3.761 16.5354 3.596 16.1844C2.021 12.8394 2.158 9.55745 4.304 6.52445C6.455 3.48245 9.491 2.18445 13.224 2.56445C13.4 2.58145 13.575 2.60645 13.794 2.64145ZM19.708 13.6454C19.976 12.5494 20.008 11.4384 19.746 10.3474C18.958 7.05944 16.912 4.92845 13.586 4.25445C10.323 3.59445 7.583 4.69445 5.65 7.39245C3.714 10.0944 3.672 12.9924 5.27 15.8954C5.475 16.2684 5.53 16.5754 5.405 16.9734C5.177 17.7014 5 18.4454 4.777 19.2714C5.702 19.0314 6.513 18.8014 7.335 18.6214C7.568 18.5704 7.873 18.5974 8.077 18.7094C12.773 21.2944 18.355 18.9094 19.708 13.6454Z",
    fill: "url(#paint0_linear_1003_10804)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74595 8.1581C9.92495 8.5851 10.0459 8.9981 10.2559 9.3611C10.5559 9.8791 10.4649 10.3141 10.0509 10.6791C9.60595 11.0711 9.67195 11.4041 9.99095 11.8541C10.7259 12.8901 11.6489 13.6671 12.8139 14.1761C13.1339 14.3161 13.3769 14.3401 13.5839 14.0191C13.6699 13.8871 13.7899 13.7791 13.8899 13.6551C14.4729 12.9291 14.2899 12.9351 15.2139 13.3361C15.5049 13.4631 15.7959 13.5981 16.0649 13.7641C16.3349 13.9291 16.7449 14.0991 16.7969 14.3341C16.9149 14.8541 16.7489 15.3821 16.3149 15.7681C15.5149 16.4801 14.5949 16.5981 13.5899 16.3201C11.4159 15.7201 9.74395 14.4161 8.46295 12.6101C8.01095 11.9731 7.60695 11.2661 7.35295 10.5321C7.04495 9.6381 7.26295 8.7761 7.89895 8.0191C8.27395 7.5741 8.72895 7.4741 9.22395 7.5931C9.42295 7.6411 9.56195 7.9371 9.74595 8.1581Z",
    fill: "url(#paint1_linear_1003_10804)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_10804",
    x1: 2.5,
    y1: 11.9997,
    x2: 21.4998,
    y2: 11.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1003_10804",
    x1: 7.21484,
    y1: 12.0029,
    x2: 16.8339,
    y2: 12.0029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.7fa2c0eca856e5f2585697d30efa47fe.svg";
export { ForwardRef as ReactComponent };